import { createAsyncThunk } from '@reduxjs/toolkit';
import { getAuth, getRedirectResult } from 'firebase/auth';
import { CLIENT_ROLE } from 'routes/client/constants';

import { app as firebaseApp } from 'src/firebase-client';
import { signIn } from './sign-in';

export const checkRedirectSignIn = createAsyncThunk<boolean, void, { rejectValue: string }>(
  'admin/checkSignInRedirect',
  async (data, { rejectWithValue, dispatch }) => {
    try {
      const firebaseAuth = getAuth(firebaseApp);
      const redirectResult = await getRedirectResult(firebaseAuth);
      console.log('redirectResult', redirectResult);
      if (redirectResult) {
        const user = redirectResult.user;
        const role: CLIENT_ROLE =
          window.localStorage.getItem('role') === CLIENT_ROLE.ARTIST ? CLIENT_ROLE.ARTIST : CLIENT_ROLE.USER;

        console.log('checkSignInRedirect:', role);

        await dispatch(
          signIn({
            uid: user.uid,
            name: user.displayName || '',
            email: user.email || '',
            pictureURL: user.photoURL || '',
            role,
          }),
        );

        return true;
      }
    } catch (e) {
      return rejectWithValue((e as Error).message);
    }

    return false;
  },
);
